import { render, staticRenderFns } from "./jak-kupic-akcje-intel.md?vue&type=template&id=09c4fcc7&"
var script = {}


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports